import { FC} from 'react';
import Shimmer from '@components/Shimmer';
import classes from './checkoutNew.module.scss';

const LoadingShimmer: FC = () => (
  <div className={classes.container}>
    <div className={classes.checkoutContent}>
      <div className={classes.shimmerContainer}>
        <div className={classes.shimmerTitle}>
          <Shimmer message={''} rounded={false} />
        </div>
        <div className={classes.shimmerLarge}>
          <Shimmer message={''} rounded={false} />
        </div>
        <div className={classes.shimmerMedium}>
          <Shimmer message={''} rounded={false} />
        </div>
        <div className={classes.shimmerButton}>
          <Shimmer message={''} rounded={false} />
        </div>
      </div>
    </div>
  </div>
);
export default LoadingShimmer;
